import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { FormattedInput } from '../FormattedInput/FormattedInput';
/**
 * Standard ZIP code wrapper composing the
 * standard NerdWallet formatted input component.
 *
 * There are some props that we don't allow the consumers
 * to override (like type) on the underlying Formatted (and
 * thus Input) component.
 *
 * See FormattedInput for the base formatted input component,
 * as well as reference to the underlying react-number-format
 * lib. react-number-format provides numerous props to override
 * the formatted input if desired (like format and mask).
 *
 * InputZIP has an opinionated design, and some of those props
 * are not surfaced in InputZIP.propTypes.
 */

export var InputZIP = function InputZIP(_ref) {
  var label = _ref.label,
      format = _ref.format,
      value = _ref.value,
      placeholder = _ref.placeholder,
      otherProps = _objectWithoutProperties(_ref, ["label", "format", "value", "placeholder"]);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({
    label: label // Format will always be 5 digits
    // for InputZIP
    ,
    format: "#####",
    placeholder: placeholder // By default we force a fixed-width
    // InputZIP to maintain consistency
    ,
    small: true,
    value: value
  }, otherProps, {
    // Used to restrict what's available
    // to mobile users via keyboard. We
    // don't use the pattern attribute
    // as that will trigger validation in some
    // browsers like Firefox.
    type: "tel"
  }));
};
InputZIP.propTypes = {
  /**
   * The default label associated with
   * the input field. Should always be supplied
   * to meet accessibility best practices.
   */
  label: PropTypes.string,

  /**
   * In general all input components should be controlled,
   * which means their value  is
   * passed into the component, and state is maintained
   * within the React component as opposed to using
   * refs from the DOM.
   *
   * Although generally required, default to ''.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
InputZIP.defaultProps = {
  label: 'ZIP code',
  value: ''
};